import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutEquipmentIssuedTractor extends Layout {
	panelEquipment: Panel;
	sourceEquipmentIssued: DataSource;
	tableEquipmentIssued: Table;
}
